module.exports = __webpack_public_path__ + "assets/images/magazine_972b97750a38253fdc93917c5af56bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/exercise-5/magazine.png
// module id = 280
// module chunks = 0